import styled from 'styled-components';
import { pxToRem } from 'Styles/utils/utils';

export const Terms = styled.span`
  display: block;
  text-align: center;
  margin-top: auto;
  font-size: ${({ theme: { fontSizes } }) => pxToRem(fontSizes.xs)};
`;

export const ButtonStyledLink = styled.button`
  ${({ theme: { typography } }) => typography.fds_text_semibold_XS};
  cursor: pointer;
  color: ${({ theme: { colors } }) => colors.sky_500};
  margin-top: ${({ theme: { spacing } }) => spacing.spacing_04};
`;
